export const ACTION_TOOGLE_MENU = "TOOGLE_MENU";
export const ACTION_CHANGE_OPEN = "CHANGE_OPEN";
export const ACTION_TOGGLE_MINI = "TOGGLE_MINI";
export const ACTION_SET_MINI = "SET_MINI";

// Temporary drawer (small screens): open / closed.
export const toggleMenu = () => ({ type: ACTION_TOOGLE_MENU });

export const setOpenMenu = (open) => ({ type: ACTION_CHANGE_OPEN, open });

// Permanent drawer (desktop): extended / icons only.
export const toggleMini = () => ({ type: ACTION_TOGGLE_MINI });

export const setMini = (mini) => ({ type: ACTION_SET_MINI, mini });
